// src/components/FooterPro.js

import React, { useContext } from 'react';
import { FaList, FaUserCircle } from 'react-icons/fa';
import './Footer.css';
import { TabContext }   from '../context/TabContext';
import { ModalContext } from '../context/ModalContext';
import ModalNewPet      from '../components/ModalNewPet';

export default function FooterPro() {
  const { activeTab, setActiveTab }          = useContext(TabContext);
  const { modalStacks, openModal, closeModal } = useContext(ModalContext);

  const currentStack = modalStacks[activeTab] || [];
  const newPetModal  = currentStack.find(m => m.metadata?.isNewPetModal);
  const footerDisabled = Boolean(newPetModal);

  // ─── [1] Handler “Mascotas” ─────────────────────────────────────────
  const handlePets = () => {
    if (activeTab === 'prof_profile') {
      setActiveTab('prof_pets');
      return;
    }
    if (activeTab === 'prof_pets') {
      if (currentStack.length > 0) {
        closeModal('prof_pets');
      } else {
        const c = document.querySelector('.pro-container');
        if (c) c.scrollTo({ top: 0, behavior: 'smooth' });
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  // ─── [2] Handler “Perfil” ───────────────────────────────────────────
  const handleProfile = () => {
    if (activeTab === 'prof_pets') {
      setActiveTab('prof_profile');
      return;
    }
    if (activeTab === 'prof_profile') {
      const c = document.querySelector('.pro-profile-container');
      if (c) c.scrollTo({ top: 0, behavior: 'smooth' });
      else window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // ─── [3] Handler “Nueva Mascota” (sin duplicados) ───────────────────
  const handleNewPet = () => {
    // Recorremos todas las pilas de modales para ver si ya hay un ModalNewPet
    const alreadyOpen = Object.values(modalStacks).some(stack =>
      stack.some(modal => modal.metadata?.isNewPetModal)
    );
    if (alreadyOpen) return; // ya hay uno abierto: nada que hacer

    // Abrimos el nuevo modal, marcándolo con metadata.isNewPetModal
    openModal(
      <ModalNewPet />,
      {
        tab: activeTab,
        metadata: { isNewPetModal: true },
        overlayClassName: 'pet-detail-overlay'    //  IMPORTANTE para abrir los modales con el ancho máximo (Skeleton)
      }
    );
  };

  // ─── [4] Fondo fijo (opaco) ─────────────────────────────────────────
  const bg = 'rgba(41, 163, 255, 1)';

  return (
    <footer
      className={`footer footer-pro${footerDisabled ? ' footer-disabled' : ''}`}
      style={{ backgroundColor: bg }}
    >
      {/* sección izquierda: Mascotas */}
      <div
        className="footer-section footer-left"
        onClick={!footerDisabled ? handlePets : undefined}
        style={{ pointerEvents: footerDisabled ? 'none' : 'auto' }}
      >
        <FaList size={22} color="#fff" />
      </div>

      {/* botón central flotante: Nueva Mascota */}
      <div
        className="footer-center-button"
        onClick={!footerDisabled ? handleNewPet : undefined}
        style={{ pointerEvents: footerDisabled ? 'none' : 'auto' }}
      >
        <img src="/logo512W.png" alt="New Pet" />
      </div>

      {/* sección derecha: Perfil */}
      <div
        className="footer-section footer-right"
        onClick={!footerDisabled ? handleProfile : undefined}
        style={{ pointerEvents: footerDisabled ? 'none' : 'auto' }}
      >
        <FaUserCircle size={22} color="#fff" />
      </div>
    </footer>
  );
}
